import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"
import { RecruitmentStatus } from "~/api/_common/types-for-recruitment"

const getPath = (id: number) => `/companies/${id}/recruitment`

export const fetchGetCompaniesRecruitment = defineFetcher((id: number): Promise<GetCompaniesRecruitment> => {
  return GET(getPath(id))
})

interface GetCompaniesRecruitment {
  new_grad_jobs: unknown[]
  short_internships: unknown[]
  long_internships: LongInternship[]
  events: unknown[]
}

// ApplicationCaseLongInternship と型が似ている、、？ →統合できるか試す
interface LongInternship {
  id: number
  title: string
  company_id: number
  job_type: string
  status: RecruitmentStatus
  category_name: string
  category_display: string
  thumbnail_img_url: string
  url: string
  company: Company
}

interface Company {
  id: number
  name: string
  main_img_filename: string
  company_overview: string
  url: string
  main_img_url: string
}
